import type { LoginAutenticado, UserToken } from '@/types/auth'

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'
const USER_DATA_KEY = 'userData'

export const getAccessToken = (): string | null => localStorage.getItem(ACCESS_TOKEN_KEY)

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY)

export const getUserData = (): UserToken | null => {
  const raw = localStorage.getItem(USER_DATA_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as UserToken
  } catch {
    return null
  }
}

export const saveSession = (login: LoginAutenticado) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, login.accessToken)
  localStorage.setItem(REFRESH_TOKEN_KEY, login.refreshToken)
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(login.userToken))
}

export const clearSession = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(USER_DATA_KEY)
}
